module.exports = __webpack_public_path__ + "ASC_logo-a99b928762380a4c675c6531c96cd061.png";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/product-labels/ASC_logo.png
// module id = 73
// module chunks = 0